import { useToasts } from '@brunommsilva/react-foundations';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useCreateTransaction from '../../../hooks/transactions/use-create-transaction';
import TransactionForm, { FormState } from './transaction-form';

interface CreateTransactionFormProps {
  onSuccess?: () => void;
  onCancel?: () => void;
  isDialog?: boolean;
  initialValues?: FormState;
}

const CreateTransactionForm = ({
  onSuccess,
  onCancel,
  isDialog = false,
  initialValues,
}: CreateTransactionFormProps) => {
  const { t } = useTranslation();
  const { showToast } = useToasts();
  const {
    createTransaction,
    isCreating,
    wasCreatedWithSuccess,
    wasCreatedWithoutSuccess,
  } = useCreateTransaction();

  useEffect(() => {
    if (wasCreatedWithSuccess) {
      showToast({
        title: t('CREATE_TRANSACTION_SUCCESS_TOAST.TITLE'),
        message: t('CREATE_TRANSACTION_SUCCESS_TOAST.MESSAGE'),
      });
      if (onSuccess) {
        onSuccess();
      }
    }
    if (wasCreatedWithoutSuccess) {
      showToast({
        title: t('CREATE_TRANSACTION_ERROR_TOAST.TITLE'),
        message: t('CREATE_TRANSACTION_ERROR_TOAST.MESSAGE'),
        type: 'error',
      });
    }
  }, [
    wasCreatedWithSuccess,
    wasCreatedWithoutSuccess,
    onSuccess,
    showToast,
    t,
  ]);

  const handleSubmit = (values: FormState) => {
    createTransaction({
      amount: values.amount!,
      date: values.date!,
      type: values.type!,
      description: values.description,
      otherAccountId: values.account?.id,
      accountId: values.otherAccount!.id,
      categoryId: values.category!.id,
    });
  };

  return (
    <TransactionForm
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isSubmitting={isCreating}
      submitLabel={t('SUBMIT')}
      title={t('REGISTER_NEW_TRANSACTION')}
      isDialog={isDialog}
    />
  );
};

export default CreateTransactionForm;
